import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { CookiesProvider } from 'react-cookie';
import { SnackbarProvider } from "notistack";
import { ThemeProvider } from "@mui/material/styles";
import { baseTheme } from "./libs/theme";
import { CssBaseline } from "@mui/material";
import "./assets/styles/index.sass";
import { RecoilRoot } from "recoil";
import * as Sentry from "@sentry/react";


Sentry.init({
  dsn: "https://477474ee8387d3bb1f3195fd232b2673@crypster.net/sentry/10",
});


const root = ReactDOM.createRoot(document.getElementById("root"));

const SnackbarWrapper = (props) => {
  return (
    <SnackbarProvider
      hideIconVariant
      maxSnack={5}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      style={{
        borderRadius: 20,
        boxShadow: "0px -2px 14px -4px rgba(0, 0, 0, 0.12), 0px 8px 14px -4px rgba(0, 0, 0, 0.16)",
        padding: "10px 20px",
        fontSize: 12,
        fontWeight: 400,
        minWidth: 150,
        backgroundColor: "#fff",
        color: "#010D03",
        maxWidth: "585px"
      }}
    >
      {props.children}
    </SnackbarProvider>
  );
};

root.render(
  <ThemeProvider theme={baseTheme}>
    <CssBaseline />
    <RecoilRoot>
      <CookiesProvider>
        <BrowserRouter>
          <SnackbarWrapper>
            <App />
          </SnackbarWrapper>
        </BrowserRouter>
      </CookiesProvider>
    </RecoilRoot>
  </ThemeProvider>
);
